<template>
  <main class="base q-mt-lg">
    <div class="column">
      <div style="width: 100%" class="row border-bottom">
        <img src="../../../assets/transferencia.png" alt="" />
      </div>
      <div style="width: 100%" class="row border-bottom">
        <span class="text-bold border-right" style="width: 10%">Origem:</span>
        <span
          class="text-bold border-right row justify-center"
          style="width: 30%"
          v-if="data.unidadeOrigem"
        >
          {{ data.unidadeOrigem.unidade.nome }}
        </span>
        <span
          class="text-bold border-right row justify-center"
          style="width: 20%"
          >Nº DO ALMOX</span
        >
        <span
          class="text-bold border-right row justify-center"
          style="width: 20%"
          >Nº DO PEDIDO</span
        >
        <span
          class="text-bold border-right row justify-center"
          style="width: 20%"
          >Nº DO ROMANEIO</span
        >
      </div>
      <div style="width: 100%" class="row border-bottom">
        <div class="column border-right" style="width: 40%">
          <div class="row border-bottom">
            <span class="text-bold border-right" style="width: 25%"
              >Destino:</span
            >
            <span
              v-if="data.unidadeDestino"
              style="width: 75%"
              class="text-bold row justify-center"
              >{{ data.unidadeDestino.unidade.nome }}</span
            >
          </div>
          <div class="row">
            <span class="text-bold border-right" style="width: 25%">Data:</span>
            <span
              v-if="data.marcoTemporal"
              style="width: 75%"
              class="text-bold row justify-center"
            >
              {{
                data.marcoTemporal.createdAt
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </span>
          </div>
        </div>
        <div class="row" style="width: 60%">
          <div
            class="text-bold border-right row justify-center align"
            style="width: 33.4%"
          >
            <span v-if="data.almox">{{ data.almox.nome }}</span>

            <span v-else>Sem Almox</span>
          </div>

          <div
            class="text-bold border-right row justify-center align"
            style="width: 33.2%"
          >
            <span v-if="data.pedido">{{ data.pedido.numero }}</span>

            <span v-else>Sem Nº pedido</span>
          </div>
          <span
            v-if="data.numero"
            class="text-bold border-right row justify-center align"
            style="width: 33%"
            >{{ data.numero }}</span
          >
        </div>
      </div>
    </div>

    <div style="width: 100%" class="q-mt-md border-top">
      <div style="width: 100%" class="row border-top border-bottom">
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 10%"
          >ITEM</span
        >
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 15%"
          >Nome do Material</span
        >
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 15%"
          >DESCRIÇÃO DO MATERIAL</span
        >
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 15%"
          >SOLICITANTE</span
        >
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 15%"
          >SETOR SOLICITANTE</span
        >
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 15%"
          >Nº PATRIMÔNIO
        </span>
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 15%"
          >Nome do Fornecedor
        </span>
      </div>

      <section style="width: 100%" v-if="data.itens">
        <div
          v-for="(ferramenta, index) in data.itens.ferramentas"
          :key="index"
          style="width: 100%"
          :class="{ quebra: index == 32 || (index + 1) % 75 == 0 }"
          class="row border-top border-bottom"
        >
          <span
            class="text-bold border-right row justify-center"
            style="width: 10%"
            >{{ index + 1 }}</span
          >
          <span
            class="text-bold border-right row justify-center"
            style="width: 15%"
            >{{ ferramenta.nome }}</span
          >
          <span
            class="text-bold border-right row justify-center"
            style="width: 15%"
            >{{ ferramenta.descricao }}</span
          >
          <span
            v-if="data.solicitante && data.solicitante.usuario"
            class="text-bold border-right row justify-center"
            style="width: 15%"
            >{{ data.solicitante.usuario.nome }}</span
          >
          <span
            v-else-if="data.solicitante"
            class="text-bold border-right row justify-center"
            style="width: 15%"
            >{{ data.solicitante.nome }}</span
          >

          <span
            v-else
            class="text-bold border-right row justify-center"
            style="width: 15%"
            >Solicitante sem nome</span
          >

          <span
            v-if="data.solicitante && data.solicitante.usuario"
            class="text-bold border-right row justify-center"
            style="width: 15%"
            >{{ data.solicitante.usuario.ghe }}
          </span>

          <span
            v-else
            class="text-bold border-right row justify-center"
            style="width: 15%"
            >.
          </span>
          <span
            class="text-bold border-right row justify-center"
            style="width: 15%"
            >{{ ferramenta.patrimonio }}
          </span>
          <span
            v-if="ferramenta.fornecedor"
            class="text-bold border-right row justify-center"
            style="width: 15%"
            >Nome: {{ ferramenta.fornecedor.nome }},CNPJ:
            {{ ferramenta.fornecedor.cnpj }}
          </span>
          <span
            v-else
            class="text-bold border-right row justify-center"
            style="width: 15%"
          >
            sem_fornecedor
          </span>
        </div>
      </section>
    </div>

    <div
      v-if="data.itens"
      :style="{ marginTop: 350 / data.itens.ferramentas.length + 'px' }"
      class="column"
      style="width: 100%"
    >
      <div
        style="width: 100%; height: 60%"
        class="row border-top border-bottom"
      >
        <div style="width: 70%" class="column border-right">
          <div class="row border-bottom">
            <span style="width: 30%" class="text-bold border-right"
              >CONDUTOR:</span
            >
            <span
              class="row justify-center text-bold"
              v-if="data.transportador"
              style="width: 70%"
              >{{ data.transportador.nome }}</span
            >
          </div>
          <div class="row border-bottom">
            <span style="width: 30%" class="text-bold border-right"
              >MATRICULA:</span
            >
            <span
              class="row justify-center text-bold"
              v-if="data.transportador"
              style="width: 70%"
              >{{ data.transportador.matricula }}</span
            >
          </div>
          <div style="width: 100%" class="row border-bottom">
            <span style="width: 30%" class="text-bold border-right"
              >PLACA DO VEICULO:</span
            >
            <span
              class="row justify-center text-bold"
              v-if="data.transportador"
              style="width: 70%"
              >{{ data.transportador.veiculo.placa }}</span
            >
          </div>
        </div>
        <div v-if="data.historicos_concatenados" style="width: 30%">
          <span style="width: 100%"
            >OBS: {{ data.historicos_concatenados }}</span
          >
        </div>
      </div>
    </div>

    <div style="width: 100%" class="row">
      <div class="border-right row justify-center text-bold" style="width: 70%">
        Valor Total
      </div>
      <div style="width: 30%"></div>
    </div>

    <div style="width: 100%" class="row border-top">
      <div class="column border-right" style="width: 50%">
        <div style="width: 100%" class="row border-bottom">
          <span style="width: 30%" class="border-right text-bold">NOME:</span>
          <span
            v-if="data.requisitante"
            class="row justify-center text-bold"
            style="width: 70%"
            >{{ data.requisitante.usuario.nome }}</span
          >
        </div>
        <div class="row border-bottom" style="width: 100%">
          <span style="width: 30%" class="border-right text-bold"
            >MATRICULA:</span
          >
          <span
            class="row justify-center text-bold"
            v-if="data.requisitante"
            style="width: 70%"
            >{{ data.requisitante.usuario.matricula }}</span
          >
        </div>
        <div class="row border-bottom" style="width: 100%">
          <span style="width: 30%" class="border-right text-bold size">
            ASSINATURA:</span
          >
          <span style="width: 70%"></span>
        </div>
      </div>
      <div class="column" style="width: 50%">
        <div style="width: 100%" class="row border-bottom">
          <span style="width: 30%" class="text-bold border-right">NOME:</span>
          <span
            v-if="data.recebedor"
            class="row justify-center text-bold"
            style="width: 70%"
            >{{ data.recebedor.usuario.nome }}</span
          >
        </div>
        <div class="row border-bottom">
          <span style="width: 30%" class="text-bold border-right"
            >MATRICULA:</span
          >
          <span
            v-if="data.recebedor"
            class="row justify-center text-bold"
            style="width: 70%"
            >{{ data.recebedor.usuario.matricula }}</span
          >
        </div>
        <div class="row border-bottom">
          <span style="width: 30%" class="text-bold border-right size"
            >ASSINATURA:</span
          >
          <span style="width: 70%"></span>
        </div>
      </div>
    </div>

    <div style="width: 100%" class="row">
      <div style="width: 50%">
        <span
          class="text-bold border-right row justify-center"
          style="width: 100%"
          >EMISSOR</span
        >
      </div>
      <div style="width: 50%">
        <span class="text-bold row justify-center" style="width: 100%"
          >RECEBEDOR</span
        >
      </div>
    </div>
  </main>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default {
  setup() {
    const $route = useRoute();
    const id = $route.params.id;
    const data = ref(false);

    const store = useStore();
    //const router = useRouter();

    const getData = async () => {
      try {
        store.dispatch("pdt/hiddenHeader", false);
        let response = await store.dispatch("fer/getDetalheTransferencia", {
          id,
        });
        data.value = response.data;

        /* setTimeout(async () => {
          window.print();
        }, 1500);

        setTimeout(async () => {
          router.push({ name: "detalheTransferencia", params: { id: id } });
        }, 3000);*/
      } catch (error) {
        ("t");
      }
    };

    onMounted(getData);
    return {
      getData,
      data,
    };
  },
};
</script>

<style>
.base {
  border: 1px solid black;
}

.border-left {
  border-left: 1px solid black;
}

.border-right {
  border-right: 1px solid black;
}

.border-bottom {
  border-bottom: 1px solid black;
}

.border-top {
  border-top: 1px solid black;
}

.align {
  align-items: center;
}

.quebra {
  page-break-after: always !important;
}

@media print {
  p,
  span {
    font-size: 8px !important;
  }
  .size {
    font-size: 11px !important;
  }
  img {
    width: 100%;
  }
}
</style>
